import { useState } from "react";

export default function useComCode() {
    const getComCode = () => {
        const comCodeString = localStorage.getItem('comCode');
        const comCode = JSON.parse(comCodeString);
        return comCode?.comCode
    };

    const [comCode, setComCode] = useState(getComCode());

    const saveComCode = comCode => {
        localStorage.setItem('comCode', `{"comCode":"${comCode}"}`);
        setComCode(comCode);
    };

    return {
        setLoggedComCode: saveComCode,
        loggedComCode: comCode
    }
}
